import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class KngFooterService 
{
	private isActionFooterPresent$: BehaviorSubject<boolean> =
		new BehaviorSubject<boolean>(false);

	get isActionFooterPresent(): boolean 
	{
		return this.isActionFooterPresent$.value;
	}

	public updateActionFooterPresent(value: boolean): void 
	{
		this.isActionFooterPresent$.next(value);
	}
}
